// login-redirect.guard.ts

import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const LoginRedirectGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.getUser();
  if (user?.role === 'superadmin' || user?.role === 'admin') {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
